import './Dropdown.scss'

import React, { Component, ReactNode } from 'react'
import { Manager } from 'react-popper'

import DropdownMenu from './DropdownMenu'
import DropdownMenuItem from './DropdownMenuItem'
import DropdownTrigger from './DropdownTrigger'

interface ManagerProps {
  children: ReactNode
}

export default class Dropdown extends Component<ManagerProps> {
  public static Menu = DropdownMenu
  public static MenuItem = DropdownMenuItem
  public static Trigger = DropdownTrigger
  public render() {
    return <Manager {...this.props} />
  }
}
